import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebook = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 24,
		height: 24,
		rx: 12,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.6919 8.37997V10.4947H14.9994L14.634 13.3435H12.6919V19.9068C12.3025 19.968 11.9041 20 11.4997 20C11.0329 20 10.5745 19.9578 10.1281 19.8762V13.3435H8V10.4947H10.1281V7.90722C10.1281 6.30193 11.2759 5 12.6925 5V5.00136C12.6967 5.00136 12.7003 5 12.7045 5H15V7.46372H13.5C13.0543 7.46372 12.6925 7.87389 12.6925 8.37929L12.6919 8.37997Z",
		fill: "white"
	})]
});
export default SvgFacebook;
